<template>
  <kinesis-container event="scroll" :duration="500">
    <kinesis-element class="circle-red" :strength="50"></kinesis-element>
    <kinesis-element
      class="square-blue"
      :strength="20"
      type="translate"
      :cycle="0.5"
      axis="y"
    ></kinesis-element>
  </kinesis-container>
</template>

<script>
import KinesisContainer from "./kinesis-container";
import KinesisElement from "./kinesis-element";
export default {
  components: {
    KinesisContainer,
    KinesisElement
  }
};
</script>

<style lang="scss" scoped>
.circle-red {
  width: 50px;
  height: 50px;
  background-color: $color-red;
}

.square-blue {
  width: 80px;
  height: 10px;
  background-color: salmon;
}
</style>
